import { oneApi } from 'config/api'

export default {
  props: {
    // 组件名称
    componentName: {
      default: '',
      type: String,
    },
    // 组件类型
    componentType: {
      default: 0,
      type: Number,
    },
    // 组件标题
    componentTitle: {
      default: '',
      type: String,
    },
    // 组件ID
    moduleId: {
      default: 0,
      type: Number,
    },
    // 分类标题
    title: {
      default: '',
      type: String,
    },
    // 打开方式
    // page、module
    targetType: {
      default: '',
      type: String,
    },
    // 是否启用频道组
    enableGroup: {
      default: false,
      type: Boolean,
    },
    // 一级分类列表
    category: {
      default: () => [],
      type: Array,
    },
    // 分类组列表
    categoryGroup: {
      default: () => [],
      type: Array,
    },
    // 锚点定位
    anchor: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    const { locale } = this.$store.state
    return {
      langContext: this.$t('dynamicComponents.Category'),
      hover: null,
      selectedGroupIndex: 0,
      selectedIndex: 0,
      loadingModules: true,
      moduleList: [],
      locale,
    }
  },
  methods: {
    /**
     * 获取模块列表数据
     * @param {Array} list 模块id列表
     */
    async queryModuleList(list, preId = '') {
      if (!list || !list.length) {
        // 该分类未配置任何模块：关闭 loading，避免一直停留在加载占位转圈
        this.loadingModules = false
        this.moduleList = []
        return
      }
      const moduleIdList = list.map((item) => item.id)
      this.loadingModules = true
      const params = {
        moduleIdList,
      }
      const res = await this.$axios.post(oneApi.queryPageModule, params, { rewritePostBody: true })
      this.loadingModules = false
      if (res.code !== 0) {
        return
      }
      try {
        const moduleList = []
        res.data.moduleList.forEach((item) => {
          if (item.content) {
            const modueleContent = JSON.parse(item.content)
            modueleContent.moduleId = item.id
            modueleContent.preId = preId
            const modueleCompData = modueleContent.componentData || {}
            if (item.type === 46 && Array.isArray(modueleCompData.dataList) && !modueleCompData.dataList.length) return
            moduleList.push(modueleContent)
          }
        })
        this.moduleList = moduleList
        console.log('moduleList', moduleList)
      } catch (error) {
        console.log(error)
      }
    },

    addClass(val) {
      this.hover = val
    },

    removeClass() {
      this.hover = null
    },

    getVisuallyTrackData(item) {
      return {
        cms_component_type: item.componentType,
        cms_component_name: item.componentName,
        cms_component_title: item.componentTitle,
        cms_component_id: item.moduleId,
        previous_source: this.$route.name,
      }
    },

    getCategoryClickTrackData(categoryName) {
      return {
        cms_component_type: this.componentType,
        cms_component_name: this.componentName,
        cms_component_title: this.componentTitle,
        cms_component_id: this.moduleId,
        card_name: '0',
        button_name: categoryName,
        previous_source: this.$route.name,
      }
    },

    /**
     * 更新URL参数 - 记录当前组件的moduleId和current index
     * @param {Number} index 当前分类索引
     * @param {Object} item 分类项
     * @param {Number} groupIndex 分类组索引（可选）
     */
    updateUrlWithCurrentState(index, item, groupIndex = null) {
      const params = {}

      // 如果有分类组，添加group参数
      if (groupIndex !== null && this.enableGroup) {
        params.group = groupIndex
        params.groupName = this.categoryGroup[groupIndex]?.name || ''
      } else {
        params.group = null
        params.groupName = null
      }
      // 如果有锚点，添加anchor参数 且不更改moduleId和current
      if (this.anchor) {
        params.anchorId = item.moduleList[0].id
      } else {
        params.anchorId = null
        params.moduleId = this.moduleId
        params.current = index
      }

      console.log(`Category组件 ${this.moduleId} 更新URL参数:`, params)

      this.updateQueryWithoutNavigation(params)
    },

    /**
     * 从URL参数初始化组件状态
     */
    initFromUrlParams() {
      const {
        moduleId, current, categoryName, group, groupName,
      } = this.$route.query

      console.log(`Category组件 ${this.moduleId} 初始化URL参数:`, {
        moduleId, current, categoryName, group, groupName,
      })

      // 检查URL中的moduleId是否匹配当前组件的moduleId
      if (moduleId && parseInt(moduleId, 10) === this.moduleId) {
        // 处理分类组（web.vue特有）
        if (this.enableGroup && group !== undefined) {
          this.handleGroupFromUrl(group, current)
        } else if (current !== undefined) { // 处理分类
          this.handleCategoryFromUrl(current)
        }

        // 等待页面元素加载完成后再滚动
        this.$nextTick(() => {
          this.scrollToComponentTop()
        })
      }
    },

    /**
     * 处理分类组（web.vue特有）
     * @param {Number} groupIndex 分类组索引
     */
    handleGroupFromUrl(groupIndex, category = 0) {
      const index = groupIndex !== undefined ? parseInt(groupIndex, 10) : 0
      const categoryIndex = category !== undefined ? parseInt(category, 10) : 0

      // index and categoryIndex is valid
      if (index >= 0 && index < this.categoryGroup.length
          && this.categoryGroup[index].children
          && categoryIndex >= 0
          && categoryIndex < this.categoryGroup[index].children.length) {
        this.selectedGroupIndex = index
        this.selectedIndex = categoryIndex // reset category index
        this.selectedIndexCache = index
        if (this.targetType === 'module') {
          const moduleList = this.categoryGroup[index].children[categoryIndex]?.moduleList
          this.queryModuleList(moduleList)
        }
      } else {
        // if invalid, use default value
        console.warn(`Category组件 ${this.moduleId} group=${index} category=${categoryIndex} 超出范围，使用默认值`)
        this.selectedGroupIndex = 0
        this.selectedIndex = 0
        if (this.targetType === 'module' && this.categoryGroup[0]?.children[0]?.moduleList) {
          this.queryModuleList(this.categoryGroup[0].children[0].moduleList)
        }
      }
    },

    /**
     * 处理分类
     * @param {Number} categoryIndex 分类索引
     */
    handleCategoryFromUrl(categoryIndex) {
      const targetCategory = this.enableGroup
        ? this.categoryGroup[this.selectedGroupIndex]?.children
        : this.category

      const index = categoryIndex !== undefined ? parseInt(categoryIndex, 10) : 0

      // 验证 index 的有效性
      if (targetCategory && index >= 0 && index < targetCategory.length) {
        this.selectedIndex = index
        this.selectedIndexCache = index

        if (this.targetType === 'module') {
          this.queryModuleList(targetCategory[index].moduleList)
        }
      } else {
        // 如果无效，使用默认值
        console.warn(`Category组件 ${this.moduleId} category=${index} 超出范围，使用默认值`)
        this.selectedIndex = 0
        if (this.targetType === 'module' && targetCategory && targetCategory[0]?.moduleList) {
          this.queryModuleList(targetCategory[0].moduleList)
        }
      }
    },

    /**
     * 滚动到组件顶部
     */
    scrollToComponentTop() {
      this.$nextTick(() => {
        // 等待页面元素完全加载完成后再滚动
        this.waitForPageReady().then(() => {
          const element = this.$el
          if (element) {
            // const topHeader = document.getElementById('topHeader')
            // const offset = topHeader ? topHeader.offsetHeight : 70
            // const eleTop = element.getBoundingClientRect().top
            // const top =  eleTop + window.scrollY - offset
            // window.scrollTo({
            //   top: Math.max(0, top),
            //   behavior: 'smooth'
            // })
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // 元素滚动到容器顶部
            })

            console.log(`Category组件 ${this.moduleId} 滚动到顶部:`)
          }
        }).catch((error) => {
          console.warn(`Category组件 ${this.moduleId} 滚动失败:`, error)
        })
      })
    },

    /**
     * 等待页面元素加载完成
     * @param {Number} timeout 超时时间
     * @param {Number} interval 检查间隔
     */
    waitForPageReady(timeout = 10000, interval = 100) {
      return new Promise((resolve, reject) => {
        const start = Date.now()

        const checkReady = () => {
          // 检查DOM是否完全加载
          if (document.readyState === 'complete') {
            // 检查组件元素是否存在且有尺寸
            const element = this.$el
            if (element && element.offsetHeight > 0) {
              // 检查模块列表是否已加载
              if (this.moduleList && this.moduleList.length > 0) {
                resolve()
                return
              }
            }
          }

          // 超时检查
          if (Date.now() - start > timeout) {
            reject(new Error(`页面元素在 ${timeout}ms 内未完全加载`))
            return
          }

          // 继续检查
          setTimeout(checkReady, interval)
        }

        checkReady()
      })
    },

    /**
     * 更新URL query参数（不触发页面跳转）
     * @param {Object} params 参数对象
     */
    updateQueryWithoutNavigation(params = {}) {
      const url = new URL(window.location.href)
      const searchParams = new URLSearchParams(url.search)

      // 更新参数
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          searchParams.set(key, params[key])
        } else {
          searchParams.delete(key)
        }
      })

      const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`
      window.history.replaceState(null, '', newUrl)
    },
  },
}
